import React, { useState, useRef, useEffect } from 'react'
import { Button, Col, Divider, Drawer, Input, Row, Typography, message } from 'antd'
import DBService from '../../../../utils/DBService'
import { WarningOutlined } from '@ant-design/icons'
import { TurnTicketFactura } from './TurnTicketFactura'
import { useReactToPrint } from 'react-to-print'
import PosSrc from '../../../pos/PosSrc'

const { Title } = Typography

function TurnDrawer(props) {
  const [confirmClose, setConfirmClose] = useState(false)
  const [closeLoading, setCloseLoading] = useState(false)
  const [spentCash, setSpentCash] = useState(null)
  const [spentCashInfo, setSpentCashInfo] = useState('')
  const [sellByCard, setSellByCard] = useState(null)
  const [sellByeExternalServices, setSellByeExternalServices] = useState(null)
  const [cashAvailable, setCashAvailable] = useState(null)
  const [storePos, setStorePos] = useState({})
  const [total, setTotal] = useState(0)
  const [flag, setFlag] = useState(false)
  const [storeTurnState, setStoreTurnState] = useState({})
  const [symbol, setSymbol] = useState('')
  const [paymentMethods, setPaymentMethods] = useState([])
  const [sellByNewMethods, setSellByNewMethods] = useState([])
  const [sold, setSold] = useState([])
  
  useEffect(() => {
    if (props?.info?._store?.id) {
      fetchData()
    }

    async function fetchData() {
      const store = await PosSrc.getStore(props?.info?._store?.id)
      setSymbol(store.company.currency.symbol)
    }

    // eslint-disable-next-line
  }, [props?.info?._store?.id])

  // eslint-disable-next-line
  useEffect(() => { handlePrint() }, [total, flag])
  useEffect(() => { setPaymentMethods(props.paymentMethods) }, [props.paymentMethods])

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  },);

  const onStart = () => {
    onFinish()
  }

  const onFinish = async () => {
    let validate = false
    let isNan = false

    const sellByNewMethodsAux = sellByNewMethods.filter(value => Object.keys(value).length !== 0);

    const paymentMethodsAux = paymentMethods?.filter(data => data.company_id === props.companyId)  

    if (sellByNewMethodsAux.length !== paymentMethodsAux.length) {
      isNan = true
    } else {
      sellByNewMethodsAux.forEach(element => {
        if (element.total_sold.trim().length === 0) {
          isNan = true
        }
      });
    }

    if ([spentCash, sellByCard, sellByeExternalServices, cashAvailable].includes('') || [spentCash, sellByCard, sellByeExternalServices, cashAvailable].includes(null)) {
      message.warning('Todos los campos son obligatorios')
    } else if ((!Number(spentCash) && !(spentCash >= 0)) || spentCash.includes('-') || spentCash.includes('+')) {
      message.warning('El campo ¿Cuánto hubo en gastos en efectivo que no fueron compras? solo acepta valores numéricos')
    } else if ((!Number(sellByCard) && !(sellByCard >= 0)) || sellByCard.includes('-') || sellByCard.includes('+')) {
      message.warning('El campo ¿Cuánto vendiste en tarjeta? solo acepta valores numéricos')
    } else if ((!Number(sellByeExternalServices) && !(sellByeExternalServices >= 0)) || sellByeExternalServices.includes('-') || sellByeExternalServices.includes('+')) {
      message.warning('El campo ¿Cuánto vendiste en servicios externos? solo acepta valores numéricos')
    } else if ((!Number(cashAvailable) && !(cashAvailable >= 0)) || cashAvailable.includes('-') || cashAvailable.includes('+')) {
      message.warning('El campo ¿Cuánto efectivo tienes en mano al cerrar el turno? solo acepta valores numéricos')
    } else if (isNan) {
      message.warning('Los campos metodos de pago propios de la empresa solo aceptan valores numericos')
    } else {
      validate = true
    }

    if (validate) {
      setCloseLoading(true)

      let data = {
        expenses_in_not_purchases: spentCash,
        expenses_reason: spentCashInfo,
        card_sales: sellByCard,
        external_services_sales: sellByeExternalServices,
        cash_on_hand: cashAvailable,
        sold_other_payment_methods: sellByNewMethodsAux
      }

      PosSrc.closeStoreTurn(props.info._id, data)
        .then(response => {
          if (!response) {
            message.error('No hay conexión a internet')
          } else {
            const { sold_with_other_payment_methods } = response
            setSold(sold_with_other_payment_methods)
            Promise.all([
              DBService.deleteAll('turn'),
              DBService.deleteAll('products'),
              DBService.deleteAll('clients'),
              DBService.deleteAll('paymentMethods'),
              DBService.deleteAll('sells'),
              DBService.deleteAll('combos'),
            ]).then(() => {
              setConfirmClose(true)
              setCloseLoading(false)
              message.success('El turno se ha cerrado correctamente')
              setStorePos(response)
              props.loadTurnInfo()
            })
          }
        })
        .catch(err => {
          console.log(err)
          message.error('No se pudo cerrar el turno')
          return false
        })
    }
  }

  const onClose = () => {
    setConfirmClose(false)
    props.closable()
  }

  const onCancel = () => {
    setConfirmClose(false)
    props.closable()
  }

  const showTurnModal = async (key) => {
    const getStoreTurn = await PosSrc.getStoreTurn(storePos.id)
    setStoreTurnState(getStoreTurn)
    setTotal(key)
    setFlag(!flag)
  }

  const returnPrint = (key) => {
    switch (key) {
      case 1:
        return <TurnTicketFactura ref={componentRef} storeTurnState={storeTurnState} sellByNewMethods={sellByNewMethods} sold={sold} />
      default:
        break;
    }
  }

  const setSellByNewMethodsFunction = (value, index) => {
    let auxSellByNewMethods = sellByNewMethods
    auxSellByNewMethods[index - 4] = { 'payment_method_id': index, 'total_sold': value }
    setSellByNewMethods(auxSellByNewMethods)
  }

  return (
    <>
      <Drawer placement="right" closable={false} onClose={onCancel} visible={props.visible} width={800} className={'pos-drawer'}>
        <div style={{ display: 'none' }}>{returnPrint(total)}</div>
        <div>
          <Title> {'Cierre de turno'} </Title>

          <Divider className={'divider-custom-margins-users'} />
          {!confirmClose ? (
            <React.Fragment>
              <Row gutter={16} className={'section-space-field'}>
                <Col xs={2} sm={2} md={2} lg={2} className="text-center">
                  <WarningOutlined style={{ fontSize: '28px', color: 'red' }} />
                </Col>
                <Col xs={20} sm={20} md={20} lg={20}>
                  <h4>¡Atención! Al forzar el cierre del turno, se perderán las ventas de la tienda que continúen offline. Si no deseas continuar, haz click en Cancelar.</h4>
                </Col>
              </Row>
              <Row gutter={16} className={'section-space-list'}>
                <h4 className={'section-space-list-bottom pl-2'}>
                  {props.info?._store_name} | {`${props.info?._turn.start_time.slice(0, 5)} - ${props.info?._turn.end_time.slice(0, 5)}`}
                </h4>
              </Row>
              <Row gutter={16} className={'section-space-field'}>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <div className={'title-space-field pl-2'}>¿Cuánto hubo en gastos en efectivo que no fueron compras?</div>
                  <Input type="number" placeholder={'Escribe la cantidad'} onChange={e => setSpentCash(e.target.value)} size={'large'} />
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <div className={'title-space-field pl-2'}>¿De qué fueron esos gastos?</div>
                  <Input placeholder={'Escribe una breve explicacion'} onChange={e => setSpentCashInfo(e.target.value)} size={'large'} />
                </Col>
              </Row>
              <Row gutter={16} className={'section-space-field'} align="bottom">
                <Col xs={12} sm={12} md={12} lg={12}>
                  <div className={'title-space-field pl-2'}>¿Cuánto vendiste en tarjeta?</div>
                  <Input type="number" placeholder={'Escribe la cantidad'} onChange={e => setSellByCard(e.target.value)} size={'large'} />
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <div className={'title-space-field pl-2'}>¿Cuánto efectivo tienes en mano al cerrar el turno?</div>
                  <Input type="number" placeholder={'Escribe la cantidad'} onChange={e => setCashAvailable(e.target.value)} size={'large'} />
                </Col>
              </Row>
              <Row gutter={16} className={'section-space-field'} align="bottom">
                <Col xs={12} sm={12} md={12} lg={12}>
                  <div className={'title-space-field pl-2'}>¿Cuánto vendiste en servicios externos?</div>
                  <Input type="number" placeholder={'Escribe la cantidad'} onChange={e => setSellByeExternalServices(e.target.value)} size={'large'} />
                </Col>
              </Row>

              {paymentMethods?.map(data => {
                if (data.company_id === props.companyId) {
                  return (
                    data.name !== 'CASH' && data.name !== 'CARD' && data.name !== 'CREDIT' &&
                    <Row key={data.id} gutter={16} className={'section-space-field'} align="bottom">
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <div className={'title-space-field pl-2'}>{`¿Cuánto vendiste en ${data.name}`}</div>
                        <Input type="number" placeholder={'Escribe la cantidad'} onChange={e => setSellByNewMethodsFunction(e.target.value, data.id)} size={'large'} />
                      </Col>
                    </Row>
                  )
                }
              })}

            </React.Fragment>
          ) : (
            <Row gutter={16}>
              <Col sm={11}>
                <h4 className={'section-space-list-bottom title-space-top'}>Cuadre en tarjeta</h4>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={18}>Venta en tarjeta según cierre</Col>
                  <Col sm={6} className={'total-quantity'}>
                    {symbol}.{Number(sellByCard).toFixed(2)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={18}>Venta en tarjeta según POS</Col>
                  <Col sm={6} className={'total-quantity'}>
                    {symbol}.{Number(storePos.card_sales_pos).toFixed(2)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col
                    offset={18}
                    sm={6}
                    className={Number(sellByCard).toFixed(2) == Number(storePos.card_sales_pos).toFixed(2) ? 'total-quantity isOk' : 'total-quantity isnotOk'}
                  >
                    {Number(sellByCard).toFixed(2) == Number(storePos.card_sales_pos).toFixed(2) ? 'Cuadrado' : 'No cuadra'}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={18}>Venta en servicios externos según cierre</Col>
                  <Col sm={6} className={'total-quantity'}>
                    {props.symbol}. {Number(sellByeExternalServices)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={18}>Venta en servicios externos según registros</Col>
                  <Col sm={6} className={'total-quantity'}>
                    {props.symbol}. {Number(storePos.services_sales)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col
                    offset={18}
                    sm={6}
                    className={Number(sellByeExternalServices) === Number(storePos.services_sales) ? 'total-quantity isOk' : 'total-quantity isnotOk'}
                  >
                    {Number(sellByeExternalServices) === Number(storePos.services_sales) ? 'Cuadrado' : 'No cuadra'}
                  </Col>
                </Row>

                {sold?.length > 0 && sellByNewMethods?.map(data => {
                  const found = paymentMethods.find(method => method.id === data.payment_method_id)
                  
                  const foundSold = sold.find(method => method.id_payment_method === data.payment_method_id)

                  return (
                    <>
                      <h4 className={'section-space-list-bottom title-space-top'}>{`Cuadre en ${found.name}`}</h4>
                      <Row gutter={16} className={'section-space-list-bottom'}>
                        <Col sm={18}>{`Venta en ${found.name} según cierre`}</Col>
                        <Col sm={6} className={'total-quantity'}>
                          {symbol}. {Number(data.total_sold).toFixed(2)}
                        </Col>
                      </Row>
                      <Row gutter={16} className={'section-space-list-bottom'}>
                        <Col sm={18}>{`Venta en ${found.name} según POS`}</Col>
                        <Col sm={6} className={'total-quantity'}>
                          {symbol}. {Number(foundSold.total_sold_with_payment_method).toFixed(2)}
                        </Col>
                      </Row>
                      <Row gutter={16} className={'section-space-list-bottom'}>
                        <Col
                          offset={18}
                          sm={6}
                          className={Number(data.total_sold).toFixed(2) == Number(foundSold.total_sold_with_payment_method).toFixed(2) ? 'total-quantity isOk' : 'total-quantity isnotOk'}
                        >
                          {Number(data.total_sold).toFixed(2) == Number(foundSold.total_sold_with_payment_method).toFixed(2) ? 'Cuadrado' : 'No cuadra'}
                        </Col>
                      </Row>
                    </>
                  )
                })}

              </Col>
              <Col sm={1}>
                <div className="sell-divider"></div>
              </Col>
              <Col sm={12}>
                <h4 className={'section-space-list-bottom title-space-top'}>Cuadre en circulante</h4>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={16}>Turno empezó con</Col>
                  <Col sm={8} className={'total-quantity'}>
                    {symbol}.{Number(storePos?.open_petty_cash_amount).toFixed(2)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={16}>Gastado en compras</Col>
                  <Col sm={8} className={'total-quantity'}>
                    {symbol}.{Number(storePos?.expenses_in_purchases).toFixed(2)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={16}>Gastado en gastos (no compras)</Col>
                  <Col sm={8} className={'total-quantity'}>
                    {symbol}.{Number(storePos?.expenses_in_not_purchases).toFixed(2)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={16}>Depositado</Col>
                  <Col sm={8} className={'total-quantity'}>
                    {symbol}.{Number(storePos?.deposits_total).toFixed(2)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={16}>Vendido en efectivo</Col>
                  <Col sm={8} className={'total-quantity'}>
                    {symbol}.{Number(storePos?.cash_sales).toFixed(2)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={16}>Cobrado de cuentas por cobrar</Col>
                  <Col sm={8} className={'total-quantity'}>
                    {symbol}.{Number(storePos?.cash_collected_in_receivables).toFixed(2)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col sm={16}>Ajustes realizados</Col>
                  <Col sm={8} className={'total-quantity'}>
                    {symbol}.{Number(storePos?.cash_adjustments_total).toFixed(2)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom final-section'}>
                  <Col offset={3} sm={13}>
                    Deberias tener
                  </Col>
                  <Col sm={8} className={'total-quantity'}>
                    {symbol}.{Number(storePos?.closed_petty_cash_amount).toFixed(2)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col offset={3} sm={13}>
                    Tienes en tienda
                  </Col>
                  <Col sm={8} className={'total-quantity'}>
                    {symbol}.{Number(storePos?.cash_on_hand).toFixed(2)}
                  </Col>
                </Row>
                <Row gutter={16} className={'section-space-list-bottom'}>
                  <Col
                    offset={16}
                    sm={8}
                    className={
                      Number(storePos.closed_petty_cash_amount).toFixed(2) == Number(storePos.cash_on_hand).toFixed(2) ? 'total-quantity isOk' : 'total-quantity isnotOk'
                    }
                  >
                    {Number(storePos.closed_petty_cash_amount).toFixed(2) == Number(storePos.cash_on_hand).toFixed(2) ? 'Cuadrado' : 'No cuadra'}
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </div>
        <div>
          <Divider className={'divider-custom-margins-users'} />
          <Row gutter={16}>
            <Col xs={24} sm={24} md={24} lg={24}>
              <div className="text-right">
                <div>
                  {!confirmClose && (
                    <Button type={'link'} className="cancel-button" onClick={() => onCancel()}>
                      Cancelar
                    </Button>
                  )}
                  {!confirmClose ? (
                    <Button
                      loading={closeLoading}
                      htmlType="submit"
                      className="title-tendero new-button"
                      onClick={() => onStart()}
                    >
                      {'Confirmar datos'}
                    </Button>
                  ) : (
                    <div className="next-button">
                      <Button onClick={() => showTurnModal(1)} style={{ marginRight: '1rem' }} className="title-tendero new-button" >
                        Imprimir turno
                      </Button>
                      <Button htmlType="submit" className="title-tendero new-button" onClick={onClose}>
                        Finalizar
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Drawer>
      {/* <PosModalDeposit storeId={props.storeId} storeTurnId={openTurn?.id} visible={addDeposit} onClose={() => setAddDeposit(false)} /> */}
    </>
  )
}

export default TurnDrawer
